var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login" }, [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.login.apply(null, arguments)
          },
        },
      },
      [
        _c("label", { attrs: { for: "id" } }, [_vm._v("아이디")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email,
              expression: "email",
            },
          ],
          attrs: { type: "id", id: "id" },
          domProps: { value: _vm.email },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.email = $event.target.value
            },
          },
        }),
        _c("label", { staticClass: "dep-2", attrs: { for: "password" } }, [
          _vm._v("패스워드"),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.password,
              expression: "password",
            },
          ],
          attrs: { type: "password", id: "password" },
          domProps: { value: _vm.password },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.password = $event.target.value
            },
          },
        }),
        _c("button", { staticClass: "login-btn", attrs: { type: "submit" } }, [
          _vm._v("로그인"),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }